import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkspace = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.7324 9.88793C2.65806 10.2109 2.85959 10.5329 3.18251 10.6072C3.50544 10.6816 3.82748 10.48 3.90181 10.1571C4.46433 7.71342 6.09728 5.68312 8.27475 4.58514C9.3903 4.02275 10.6628 3.7 11.9999 3.7C14.793 3.7 16.874 5.04533 18.8127 7.30586L17.5093 8.60929L16.4851 9.63355H17.9336H19.3181H20.9004H21.5004V9.03355V7.45126V6.06675V4.61823L20.4761 5.64249L19.6636 6.45505C17.609 4.08272 15.2413 2.5 11.9999 2.5C10.4692 2.5 9.01221 2.8695 7.73455 3.51361L7.7345 3.51363C5.24423 4.76932 3.37638 7.09031 2.7324 9.88793ZM21.268 14.1127C21.3423 13.7898 21.1408 13.4677 20.8179 13.3934C20.4949 13.3191 20.1729 13.5206 20.0986 13.8435C19.5361 16.2872 17.9031 18.3175 15.7256 19.4155C14.6101 19.9779 13.3376 20.3006 12.0004 20.3006C9.20734 20.3006 7.12635 18.9553 5.18764 16.6948L6.49106 15.3913L7.51533 14.3671H6.0668H4.68229H3.1H2.5V14.9671V16.5494V17.9339V19.3824L3.52426 18.3581L4.33683 17.5456C6.39142 19.9179 8.75913 21.5006 12.0004 21.5006C13.5312 21.5006 14.9882 21.1311 16.2658 20.487L16.2659 20.487C18.7561 19.2313 20.624 16.9103 21.268 14.1127Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3343_5100)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M14.7916 10.5686L12.155 8.45923L9.51831 10.5686V15.0509H14.7916V10.5686Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M15.4508 11.0959L12.155 8.45923L8.85913 11.0959",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3343_5100",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 7.91,
				height: 7.91,
				fill: "currentColor",
				transform: "translate(8.19995 7.80005)"
			})
		}) })
	]
});
export default SvgWorkspace;
